/* eslint-disable */
import React, { useState, useEffect } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import usePagination from "../../helper/paginate/Pagination";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../../../pages/dashboard/yoda.css";
import "./DataTableDemo.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Select } from "antd";
import {
  Switch,
  Segmented
} from "antd";
import axios from "axios";
import AnalysisModal from "../../analysisAdsAi/AnalysisModal";
import { useTranslation } from "react-i18next";
import useIsDark from "../../../utils/isDark";
const DataTableTemplatingDemo = ({
  lgShow,
  setLgShow,
  modelShow,
  setModelShow,
  setData,
  filter,
  selectedAccount,
  setImages,
  pageSize,
}) => {
  const products = useSelector((state) => state.ProductsReducer);
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const [loadingState, setLoadingState] = useState({});
  const { t, i18n } = useTranslation();
  const [expandedRows, setExpandedRows] = useState(null);
  const isRTL = i18n.dir() === "rtl";
  const [loading, setLoading] = useState(false);
  const PER_PAGE = pageSize;
  const [page, setPage] = useState(1);
  const [filterType, setFilterType] = useState("total"); // "total" للإجمالي و "last24" لآخر 24 ساعة
  const count = Math.ceil(products.length / PER_PAGE);
  const _DATA = usePagination(products, PER_PAGE);
  const isDark = useIsDark();

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const toggleFilter = (type) => setFilterType(type);

  const getFilteredData = (rowData, field) => {
    const data =
      filterType === "last24" ? rowData.campaignInfo24 : rowData.campaignInfo;
    return data?.[field] || "ـ";
  };

  const amountSpent = (rowData) => (
    <div className="text-end p-price" style={{ color: "#6e4881" }}>
      {getFilteredData(rowData, "amountSpent")} $
    </div>
  );

  const impressions = (rowData) => {
    const impressionsValue = getFilteredData(rowData, "impressions");

    // Validate and parse the value
    const value =
      impressionsValue && !isNaN(parseFloat(impressionsValue))
        ? parseFloat(impressionsValue).toLocaleString()
        : "0";

    return <div className="text-end p-qty">{value}</div>;
  };

  //récupère et affiche le nombre d'achats effectués à partir des résultats de la campagne, en fonction du filtre appliqué.
  const purchases = (rowData) => {
    const results =
      filterType === "last24"
        ? rowData.campaignInfo24?.results
        : rowData.campaignInfo?.results;
    const purchaseResult = results?.find(
      (result) => result.action_type === "purchase"
    );
    return (
      <div className="text-end p-price" style={{ color: "#12b669" }}>
        {purchaseResult?.value || "ـ"}
      </div>
    );
  };

  const darkModeStyles = `
  /* Styles pour le mode sombre du DataTable */
  .dark .p-datatable .p-datatable-thead > tr > th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr > td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }


  /* Pour les bordures du tableau */
  .dark .p-datatable {
    border-color: #3c3a3d !important;
  }

  /* Pour les éléments expandables */
  .dark .p-datatable .p-row-expansion {
    background-color: #141414 !important;
    color: #d1d5db !important;
  }
`;

  //met à jour l'état d'une campagne publicitaire Facebook en l'activant ou en la mettant en pause, puis synchronise cette modification avec Firestore.
  const changepaid = async (data, status) => {
    const compainIdFb = data.campaignId; // افتراض أن campaignId موجود في وثيقة المنتج
    const accessToken = store.accessTokenFacebookAds;
    if (!compainIdFb) {
      Swal.fire(t("insightads.Table.facebookAds.error.title"), t("insightads.Table.facebookAds.errors.missing_campaign_id"), "error");
      return;
    }

    const apiUrl = `https://graph.facebook.com/v21.0/${compainIdFb}`;
    const isActive = status;

    try {
      // ضبط حالة التحميل لهذا المنتج
      setLoadingState((prevState) => ({ ...prevState, [data.id]: true }));

      // إرسال طلب إلى API Facebook
      const response = await axios.post(
        apiUrl,
        {
          status: isActive ? "ACTIVE" : "PAUSED",
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        // تحديث حالة الحملة الإعلانية في Firestore
        await setDoc(doc(db, "products", data.id), {
          ...data,
          facebookAds: isActive,
        });
        Swal.fire(
          t("insightads.Table.facebookAds.success.title"),
          `${t("insightads.Table.facebookAds.success.title3")} ${isActive ? t("insightads.Table.facebookAds.success.play") : t("insightads.Table.facebookAds.success.stop")} ${t("insightads.Table.facebookAds.success.title2")}`,
          "success"
        );

      } else {
        throw new Error(t("insightads.Table.facebookAds.error.update_failed"));
      }
    } catch (error) {
      console.error("خطأ في تحديث حالة الحملة الإعلانية:", error);
      Swal.fire(
        t("insightads.Table.facebookAds.error.title"),
        t("insightads.Table.facebookAds.errors.update_failed"),
        "error"
      );
    } finally {
      // إزالة حالة التحميل لهذا المنتج
      setLoadingState((prevState) => ({ ...prevState, [data.id]: false }));
    }
  };

  //boite de dialogue
  const message = () => {
    const MySwal = withReactContent(Swal);

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title:
          `<a href="https://m.me/F0orweb" target="_blank">${t("Swal.message.title")}</a>`,
        showCancelButton: true,
        confirmButtonText: t("Swal.message.confirmButton"),
        cancelButtonText: t("Swal.message.cancelButton"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
        /* Read more about handling dismissals below */
      });
  };

  const paidBodyTemplate = (rowData) => {
    const color = rowData.facebookAds ? "#12b669" : "#474747";

    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{t("insightads.published")}</Tooltip>}
      >
        <Switch
          aria-label={t("insightads.status")}
          checkedChildren="On"
          unCheckedChildren="Off"
          checked={rowData.facebookAds}
          loading={!!loadingState[rowData.id]} // إذا كان المنتج في حالة تحميل
          onChange={
            !!account.store
              ? (checked) => {
                changepaid(rowData, checked);
              }
              : () => {
                message();
              }
          }
          style={{ backgroundColor: color }}
        />
      </OverlayTrigger>
    );
  };

  const imageBodyTemplate = (rowData) => {
    // Fonction qui évalue la performance d'une campagne publicitaire en fonction du ROAS, du CTR et du nombre d'achats, et retourne une icône et un statut correspondant.
    const evaluateCampaignEmoji = () => {
      const sourceData =
        filterType === "last24" ? rowData.campaignInfo24 : rowData.campaignInfo;

      if (!sourceData?.amountSpent) return { emoji: null, status: null };

      const roas =
        parseFloat(
          sourceData?.results?.reduce((acc, curr) => {
            if (
              [
                "purchase",
                "web_in_store_purchase",
                "onsite_web_purchase",
                "omni_purchase",
                "onsite_web_app_purchase",
              ].includes(curr.action_type)
            ) {
              return acc + parseFloat(curr.value || 0);
            }
            return acc;
          }, 0)
        ) / parseFloat(sourceData?.amountSpent || 1);

      const ctr = parseFloat(sourceData?.ctr || 0);
      const purchases =
        sourceData?.results?.find((result) => result.action_type === "purchase")
          ?.value || 0;

      const goodEmoji = "/money.png";
      const averageEmoji = "/average.png";
      const badEmoji = "/bad.png";

      if (roas > 1 && ctr > 2 && purchases > 10) {
        return { emoji: goodEmoji, status: t("insightads.good") };
      } else if (
        roas > 0.5 &&
        roas <= 1 &&
        ctr >= 1 &&
        ctr <= 2 &&
        purchases >= 5 &&
        purchases <= 10
      ) {
        return { emoji: averageEmoji, status: t("insightads.average") };
      } else {
        return { emoji: badEmoji, status: t("insightads.bad") };
      }
    };
    const { emoji: campaignEmoji, status } = evaluateCampaignEmoji();

    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        <img
          src={`${rowData.image}`}
          height="75px"
          onError={(e) => (e.target.src = "/product-foorweb.png")}
          alt={rowData.image}
          className="ant-avatar ant-avatar-circle ant-avatar-image hp-bg-black-0 hp-bg-dark-100 hp-border-1 css-dev-only-do-not-override-19gw05y avatar1"
        />
        {campaignEmoji && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{`${status}`}</Tooltip>}
          >
            <img
              src={campaignEmoji}
              alt={t("ui.campaignStatus")}
              className="absolute top-0 left-0"
              style={{
                position: "absolute",
                right: "30px",
                bottom: "5px",
                zIndex: "50",
                maxWidth: "35px",
              }}
            />
          </OverlayTrigger>
        )}
      </div>
    );
  };

  const CostPerAction = (rowData) => {
    const sourceData =
      filterType === "last24" ? rowData?.campaignInfo24 : rowData?.campaignInfo;

    const purchaseResult = sourceData?.costPerAction?.find(
      (costPerAction) => costPerAction.action_type === "purchase"
    );

    const value = purchaseResult?.value
      ? parseFloat(purchaseResult.value).toFixed(2)
      : "0.00";

    return (
      <div className="text-end p-price" style={{ color: "#6e4881" }}>
        {value} $
      </div>
    );
  };

  function applyRowBackground() {
    const rows = document.querySelectorAll(".p-datatable-tbody > tr");
    rows.forEach((row, index) => {
      if (index % 2 === 0) {
        row.style.background = "transparent";
      } else {
        row.style.background = "white";
      }
    });
  }

  const fetchCampaignData = async (campaignId, productId) => {
    const accessToken = store.accessTokenFacebookAds;
    const apiUrl = `https://graph.facebook.com/v21.0/${campaignId}/insights`;

    try {
      const response = await axios.get(apiUrl, {
        params: {
          fields:
            "cpm,ctr,cost_per_action_type,account_currency,impressions,spend,actions",
          access_token: accessToken,
        },
      });

      const campaignData = response.data.data[0];

      // إعداد البيانات للحفظ
      const campaignInfo = {
        cpm: campaignData?.cpm || 0,
        ctr: campaignData?.ctr || 0,
        accountCurrency: campaignData?.account_currency || "USD",
        costPerAction: campaignData?.cost_per_action_type || [],
        impressions: campaignData?.impressions || 0,
        amountSpent: campaignData?.spend || 0,
        results: campaignData?.actions || [],
        dateStart: campaignData?.date_start || null,
        dateStop: campaignData?.date_stop || null,
      };

      // تحديث وثيقة المنتج في Firestore
      await setDoc(
        doc(db, "products", productId),
        {
          campaignInfo,
          lastFetchedFacebook: new Date().toISOString(),
        },
        { merge: true }
      );
    } catch (error) {
      console.error("Error fetching campaign data:", error);
    }
  };
  const fetchCampaignDataLast24Hours = async (campaignId, productId) => {
    const accessToken = store.accessTokenFacebookAds;
    const apiUrl = `https://graph.facebook.com/v21.0/${campaignId}/insights`;

    // احسب الوقت الحالي والوقت قبل 24 ساعة
    const now = new Date();
    const last24Hours = new Date(now.getTime() - 24 * 60 * 60 * 1000); // طرح 24 ساعة

    const since = last24Hours.toISOString().split("T")[0];
    const until = now.toISOString().split("T")[0];

    try {
      const response = await axios.get(apiUrl, {
        params: {
          fields:
            "cpm,ctr,cost_per_action_type,account_currency,impressions,spend,actions",
          time_range: JSON.stringify({ since, until }), // تمرير time_range كسلسلة JSON
          access_token: accessToken,
        },
      });

      const campaignData = response.data.data[0];

      // إعداد البيانات للحفظ
      const campaignInfo24 = {
        cpm: campaignData?.cpm || 0,
        ctr: campaignData?.ctr || 0,
        accountCurrency: campaignData?.account_currency || "USD",
        costPerAction: campaignData?.cost_per_action_type || [],
        impressions: campaignData?.impressions || 0,
        amountSpent: campaignData?.spend || 0,
        results: campaignData?.actions || [],
        dateStart: campaignData?.date_start || null,
        dateStop: campaignData?.date_stop || null,
      };

      // تحديث وثيقة المنتج في Firestore
      await setDoc(
        doc(db, "products", productId),
        {
          campaignInfo24, // حفظ البيانات في حقل جديد
          // lastFetchedFacebook: new Date().toISOString(),
        },
        { merge: true }
      );
    } catch (error) {
      console.error(
        "Error fetching campaign data for the last 24 hours:",
        error
      );
    }
  };

  const shouldFetchData = (lastFetchedFacebook) => {
    if (!lastFetchedFacebook) return true;

    const lastFetchedTime = new Date(lastFetchedFacebook).getTime();
    const currentTime = Date.now();

    const differenceInMilliseconds = currentTime - lastFetchedTime;
    const oneHourInMilliseconds = 60 * 60 * 1000;

    return differenceInMilliseconds > oneHourInMilliseconds;
  };

  useEffect(() => {
    const updateCampaignData = async () => {
      for (const product of products) {
        if (product.campaignId) {
          if (shouldFetchData(product.lastFetchedFacebook)) {
            await fetchCampaignData(product.campaignId, product.id);
            await fetchCampaignDataLast24Hours(product.campaignId, product.id);
          }
        }
      }
    };

    updateCampaignData();
  }, [products]);

  const [campaigns, setCampaigns] = useState([]); // لتخزين الحملات الإعلانية
  const accessToken = store.accessTokenFacebookAds;

  useEffect(() => {
    const fetchCampaigns = async () => {
      setLoading(true);
      try {
        if (!selectedAccount) return; // إذا لم يتم اختيار حساب

        const adAccountId = selectedAccount;

        const campaignsResponse = await axios.get(
          `https://graph.facebook.com/v17.0/${adAccountId}/campaigns`,
          {
            params: {
              fields: "id,name,status",
              access_token: accessToken,
            },
          }
        );

        const campaignsData = campaignsResponse.data.data || [];
        // معالجة الحملات بناءً على الحالة
        const processedCampaigns = campaignsData.map((campaign) => ({
          ...campaign,
          facebookAds: campaign.status === "ACTIVE", // true إذا كانت الحملة نشطة
        }));

        setCampaigns(processedCampaigns); // تحديث قائمة الحملات
      } catch (error) {
        console.error("خطأ في جلب الحملات الإعلانية:", error);
        message.error(t("ui.campaignListError"));
      } finally {
        setLoading(false); // إنهاء التحميل
      }
    };

    fetchCampaigns();
  }, [selectedAccount, t]); // يعتمد على تغيير الحساب المختار

  // حفظ الحملة الإعلانية المختارة في Firestore
  const handleCampaignSelect = async (productId, campaignId) => {
    const selected = campaigns.find((campaign) => campaign.id === campaignId);
    if (!selected) return;

    try {
      // تحديث المستند لإضافة الحملة الجديدة
      await setDoc(
        doc(db, "products", productId),
        {
          campaignId: selected.id,
          campaignName: selected.name,
          facebookAds: selected.facebookAds, // تحديث حالة الحملة (true/false)
          campaignInfo: null, // حذف الحقل
          lastFetchedFacebook: null, // حذف الحقل
        },
        { merge: true }
      );

      // إعادة جلب المعطيات
      await fetchCampaignData(selected.id, productId);
      await fetchCampaignDataLast24Hours(selected.id, productId);
      Swal.fire(t("insightads.Table.facebookAds.success.title"), "تم تسجيل الحملة الإعلانية للمنتج بنجاح.", "success");
    } catch (error) {
      console.error("خطأ في تسجيل الحملة الإعلانية:", error);
      Swal.fire(t("error"), "حدث خطأ أثناء تسجيل الحملة الإعلانية.", "error");
    }
  };

  // عرض القائمة المنسدلة لكل منتج
  const campaignSelector = (rowData) => (
    <Select
      style={{ width: "100%" }}
      placeholder={t("insightads.Table.headers.campaign")}
      loading={loading}
      value={
        rowData.campaignName
          ? rowData.campaignName.length > 15
            ? `${rowData.campaignName.slice(0, 15)}...`
            : rowData.campaignName
          : undefined
      }
      onChange={(value) => handleCampaignSelect(rowData.id, value)}
    >
      {campaigns.map((campaign) => (
        <Option
          key={campaign.id}
          value={campaign.id}
          title={campaign.name} // عرض الاسم الكامل عند التمرير
        >
          {campaign.name.length > 15
            ? `${campaign.name.slice(0, 15)}...`
            : campaign.name}
        </Option>
      ))}
    </Select>
  );

  const cpm = (rowData) => {
    const value = parseFloat(getFilteredData(rowData, "cpm"));
    return (
      <div className="text-end">
        {isNaN(value) ? "0.00" : value.toFixed(2)} $
      </div>
    );
  };

  const ctr = (rowData) => {
    const value = parseFloat(getFilteredData(rowData, "ctr"));
    return (
      <div className="text-end">
        {isNaN(value) ? "0.00" : value.toFixed(2)} %
      </div>
    );
  };

  const sortedProducts = [...products].sort((a, b) => {
    if (a.campaignId && !b.campaignId) return -1; // المنتجات التي تحتوي على campaignId أولاً
    if (!a.campaignId && b.campaignId) return 1; // المنتجات التي لا تحتوي على campaignId لاحقاً
    return 0; // المنتجات الأخرى تبقى كما هي
  });

  window.addEventListener("load", applyRowBackground);
  return (
    <div className="datatable-templating-demo">
      <div style={{ padding: "5px", textAlign: isRTL ? "right" : "left" }}>
        {/* Segmented Component لتبديل التبويبات */}
        <Segmented
          options={[
            { label: t("insightads.Table.segmented.total"), value: "total" },
            { label: t("insightads.Table.segmented.last24"), value: "last24" },
          ]}
          value={filterType}
          onChange={(value) => setFilterType(value)}
          style={{ marginBottom: 8 }}
          className="dark:text-white dark:hover:!text-white"
        />
      </div>
      <div className="">
        <style>{darkModeStyles}</style>
        <DataTable
          value={
            !!filter
              ? sortedProducts.filter(
                (product) =>
                  product.name.toLowerCase().includes(filter.toLowerCase()) ||
                  product.sku.toLowerCase().includes(filter.toLowerCase())
              )
              : sortedProducts.slice((page - 1) * PER_PAGE, page * PER_PAGE)
          }
          responsiveLayout="scroll"
          emptyMessage={t("insightads.Table.emptyMessage")}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowClassName={(rowData, rowIndex) =>
            rowIndex % 2 === 0 ? "p-row-odd" : "p-row-even"
          }
        >
          <Column
            header={t("insightads.Table.headers.product")}
            className="text-end"
            body={imageBodyTemplate}
          ></Column>
          <Column
            field="name"
            sortable
            className="text-end p-name"
            style={{ maxWidth: "250px" }}
            header={t("insightads.Table.headers.name")}
          ></Column>

          <Column
            // field="campaignInfo.cpm"
            className="text-end p-sku"
            header={t("insightads.Table.headers.cpm")}
            body={cpm}
          ></Column>
          <Column
            className="text-end p-name"
            header={t("insightads.Table.headers.ctr")}
            // field="campaignInfo.ctr"
            body={ctr}
          ></Column>
          <Column
            header={t("insightads.Table.headers.impressions")}
            className="text-end p-qty"
            // field="campaignInfo.impressions"
            body={impressions}
          />
          <Column header={t("insightads.Table.headers.purchases")} sortable className="" body={purchases} />
          <Column
            header={t("insightads.Table.headers.cpa")}
            sortable
            className=""
            body={CostPerAction}
          />
          <Column
            header={t("insightads.Table.headers.total")}
            sortable
            className=""
            body={amountSpent}
          ></Column>
          {/* <Column header="تقييم الحملة" body={evaluateCampaign} /> */}

          <Column
            header={t("insightads.Table.headers.foorai")}
            body={(rowData) => <AnalysisModal product={rowData} />}
          />
          <Column
            className="text-end p-name"
            header={t("insightads.Table.headers.campaign")}
            body={campaignSelector}
          ></Column>
          <Column
            className="text-end p-status"
            header={t("insightads.Table.headers.status")}
            body={paidBodyTemplate}
          ></Column>
        </DataTable>
      </div>
      <div className="d-flex justify-content-center py-3">
        <Stack spacing={2} dir="ltr">
          <Pagination
            count={count}
            size="large"
            page={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
            color="secondary"
            sx={{
              backgroundColor: isDark ? '#181919' : '#ffffff',
              borderRadius: 2,
              p: 2,
              '& .MuiPaginationItem-root': {
                color: isDark ? '#e1cfff' : '#000000',
                borderColor: isDark ? '#a065c0' : '#ccc',
              },
              '& .MuiPaginationItem-root.Mui-selected': {
                backgroundColor: isDark ? '#9b59bf' : '#9b59bf',
                color: '#fff',
              },
              '& .MuiPaginationItem-root:hover': {
                backgroundColor: isDark ? '#7c3aad' : '#f0f0f0',
              }
            }}
          />
        </Stack>
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
